export const moreList = [
    {
        header: 'About',
        items: [
            {
                label: 'Team',
                href: '/team',
            },
            {
                label: 'GIPHY Studios',
                href: '/giphystudios',
            },
            {
                label: 'Developers',
                href: 'https://developers.giphy.com/',
            },
            {
                label: 'Apply as a Brand',
                href: 'https://support.giphy.com/hc/en-us/articles/360019977992-Apply-For-A-Brand-Channel',
            },
            {
                label: 'FAQ',
                href: 'https://support.giphy.com/hc/en-us',
            },
            {
                label: 'Support',
                href: 'https://support.giphy.com/hc/en-us',
            },
            {
                label: 'Transparency',
                href: 'transparency/2024',
            },
            {
                label: 'Jobs',
                href: 'https://careers.shutterstock.com/us/en/search-results?keywords=giphy',
            },
        ],
    },
    {
        header: 'Artists',
        items: [
            {
                label: 'Artist Directory',
                href: '/artists',
            },
            {
                label: 'Hire a GIF Artist',
                href: 'https://support.giphy.com/hc/en-us/articles/360022661172-How-to-Hire-an-Artist-on-GIPHY',
            },
        ],
    },
    {
        header: 'Stickers',
        items: [
            {
                label: 'Originals',
                href: '/originals/stickers/studios-stickers',
            },
            {
                label: 'Trending',
                href: '/stickers/trending',
            },
            {
                label: 'Reactions',
                href: '/stickers/reactions',
            },
            {
                label: 'Packs',
                href: '/stickers/packs',
            },
        ],
    },
    {
        header: 'Apps',
        items: [
            {
                label: 'GIPHY Capture',
                href: '/apps/giphycapture',
            },
        ],
    },
] as const
